const reducer = (state, action) => {
    switch (action.type) {
        case "SET_LANGUAGE":
            return {
                ...state,
                language: action.payload,
            };
        case "SET_USERDATA":
            return {
                ...state,
                userData: action.payload,
            };
        case "SET_MODS":
            return {
                ...state,
                userData: {
                    ...state.userData,
                    mods: action.payload,
                },
            };
        case "SET_PROFILE_P1":
            return {
                ...state,
                userData: {
                    ...state.userData,
                    profile_p1: action.payload,
                },
            };
        case "SET_PROFILE_P2":
            return {
                ...state,
                userData: {
                    ...state.userData,
                    profile_p2: action.payload,
                },
            };
        case "SET_RECORD_ENSO_P1":
            return {
                ...state,
                userData: {
                    ...state.userData,
                    record_enso_p1: action.payload,
                },
            };
        case "SET_RECORD_ENSO_P2":
            return {
                ...state,
                userData: {
                    ...state.userData,
                    record_enso_p2: action.payload,
                },
            };
        case "SET_RECORD_AI":
            return {
                ...state,
                userData: {
                    ...state.userData,
                    record_ai_battle: action.payload,
                },
            };
        default:
            return state;
    }
};

export default reducer;
